module.exports = __webpack_public_path__ + "static/media/minus-hexagon.e3387821.svg";